import { render, staticRenderFns } from "./StockPage.vue?vue&type=template&id=4ee61048&scoped=true"
import script from "./StockPage.vue?vue&type=script&lang=js"
export * from "./StockPage.vue?vue&type=script&lang=js"
import style0 from "./StockPage.vue?vue&type=style&index=0&id=4ee61048&prod&lang=scss&scoped=true"
import style1 from "./StockPage.vue?vue&type=style&index=1&id=4ee61048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee61048",
  null
  
)

export default component.exports